
import {titleCase} from '@ls/js-utils';

const ScaleType = {
  Contribution: 'Contribution',
  WeightedAverage: 'WeightedAverage',
};

export default ScaleType;

export const scaleTypeOptions = Object.values(ScaleType).map(val => ({ label: titleCase(val), value: val }));

